import PrivacyPolicy from './privacyPolicy';
export default PrivacyPolicy;
